<!-- Platform Pills -->
<div class="form-group">
  <label class="form-label">{{ texts.platform }}</label>
  <app-spinner [loading]="catalog.loadingPlatforms">
    @if (catalog.platformsError) {
      <div class="inline-state inline-state--error" role="alert">
        <span>{{ texts.loadPlatformsError }}</span>
        <app-button
          [label]="'common.actions.retry' | transloco"
          variant="secondary"
          size="small"
          (onClick)="catalog.loadPlatforms()">
        </app-button>
      </div>
    } @else if (!catalog.loadingPlatforms && catalog.platforms.length === 0) {
      <p class="inline-state">{{ texts.noPlatforms }}</p>
    }
    <div class="platform-pills">
      @for (platform of catalog.platforms; track platform.value) {
        <button
          type="button"
          class="platform-pill"
          [class.active]="catalog.selectedPlatform === platform.value"
          [style.--brand]="getPlatformColor(platform.label)"
          (click)="catalog.selectPlatform(platform.value)">
          @if (getPlatformIcon(platform.label); as brand) {
            <app-brand-icon [name]="brand"></app-brand-icon>
          } @else {
            <lucide-icon name="Globe" class="icon-em"></lucide-icon>
          }
          <span>{{ platform.label }}</span>
        </button>
      }
    </div>
  </app-spinner>
</div>

<!-- Service Selection -->
<div class="form-group">
  <label class="form-label">{{ texts.service }}</label>
  @if (catalog.productsError) {
    <div class="inline-state inline-state--error" role="alert">
      <span>{{ texts.loadProductsError }}</span>
      <app-button
        [label]="'common.actions.retry' | transloco"
        variant="secondary"
        size="small"
        (onClick)="catalog.retryLoadProducts()">
      </app-button>
    </div>
  } @else if (catalog.selectedPlatform && !catalog.loadingProducts && catalog.products.length === 0) {
    <p class="inline-state">{{ texts.noProducts }}</p>
  } @else {
    <app-select
      formControlName="product"
      [options]="catalog.products"
      [loading]="catalog.loadingProducts"
      [filter]="catalog.products.length > 8"
      [filterPlaceholder]="texts.searchService"
      size="medium"
      [placeholder]="texts.selectService">
    </app-select>
  }
</div>
